<div [ngClass]="{ inlineChildElements: !requiresRecordNavigation }">
  <div class="template-title" *ngIf="requiresSelectTempElement">
    <span>
      {{ selectedTemplateTitle }}
    </span>
  </div>
  <div class="action-bar">
    <form [formGroup]="navControlsFG">
      <div [ngClass]="{ onlyRecordNavigation: requiresRecordNavigation && !requiresSelectTempElement }">
        <div class="navigation-controls" *ngIf="requiresRecordNavigation">
          <label l10nTranslate>template.record</label>
          <input type="number" name="recordNumber" formControlName="recordNumber" (blur)="onRecordNumChange()" />
          <span>/ &nbsp; {{ recordsCount }}</span>
          <button
            mat-icon-button
            color="primary"
            class="left-arrow"
            (click)="prevRecord()"
            [disabled]="prevRecordError"
          >
            <mat-icon svgIcon="leftnav"></mat-icon>
          </button>
          <button
            mat-icon-button
            color="primary"
            class="right-arrow"
            (click)="nextRecord()"
            [disabled]="nextRecordError"
          >
            <mat-icon svgIcon="rightnav"></mat-icon>
          </button>
        </div>
        <div class="errMsg" *ngIf="navControlsFG.get('recordNumber').errors">
          <div>{{ errorMessage }}</div>
        </div>
      </div>
      <div class="errMsg" *ngIf="navControlsFG.get('recordNumber').errors">
        <div>{{ errorMessage }}</div>
      </div>
      <button
        *ngIf="requiresSelectTempElement && !isUKFeaturesEnabled"
        mat-flat-button
        color="primary"
        class="change-template-btn"
        (click)="openTemplates()"
        l10nTranslate
      >
        template.changeTemplate
      </button>
    </form>
  </div>
</div>
